module.exports = __webpack_public_path__ + "static/media/AngularJS-Shield.4c732369.svg";